
import { GET_HIPPODROMES, GET_HIPPODROMES_FAILURE, GET_HIPPODROMES_SUCCESS, SET_SELECTED_HIPPODROME, SET_SELECTED_HIPPODROME_RACE_DATE } from 'Store/constants';

const initialState = {
  data: [],
  selectedHippodromeId: null,
  selectedHippodromeRaceDate: null,
  isLoading: true,
  error: null,
  raceDay: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_HIPPODROMES:
      return { ...state, isLoading: true, error: null };
    case SET_SELECTED_HIPPODROME:
      return { ...state,  selectedHippodromeId: action.payload };
    case SET_SELECTED_HIPPODROME_RACE_DATE:
      return { ...state,  selectedHippodromeRaceDate: action.payload };
    case GET_HIPPODROMES_SUCCESS:
      return { ...state, data: action?.payload?.data, raceDay: action?.payload?.raceDay, isLoading: false, error: null };
    case GET_HIPPODROMES_FAILURE:
      return { ...state, isLoading: false, error: action.payload };
    default:
      return state;
  }
};
